function init() {
  setupEventListeners();
}

function setupEventListeners() {
  document.addEventListener("quickview:loaded", async function(event) {
    var form = document.querySelector("#AddToCartForm-" + event.detail.productId + "-modal");
    handleViewItemEvent(form);
    handleProductSelectEvent(form);
  });

  document.addEventListener('cart-drawer:open', (event) => {
    handleViewCartEvent(event.detail);
  });
}

async function handleViewItemEvent(form) {
  try {
    const product = await fetchProductData(window.location.pathname);
    
    if (!product) {
      return;
    }
    
    const selectedVariantId = form.querySelector(".product-single__variants")?.value;
    
    if (!selectedVariantId) {
      return;
    }
    
    const selectedVariant = product.variants.find((variant) => variant.id == parseInt(selectedVariantId));
    
    if (!selectedVariant) {
      return;
    }

    let variantImage = "";
    variantImage = product.images.find((image) => image.id == selectedVariant.image_id);

    const products = [
      {
        id: selectedVariant.sku, // SKU
        name: product.title, // Product title
        brand: product.vendor,
        category: product.product_type,
        variant: selectedVariant.title,
        price: selectedVariant.price,
        list:
          window.location.pathname.split("/products")[0] ||
          window.location.pathname, // The list the product was discovered from
        product_id: product.id.toString(), // The product_id
        variant_id: selectedVariant.id.toString(), // id or variant_id
        compare_at_price: selectedVariant.compare_at_price || "0.0", // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
        image: variantImage.src || "", // If available, otherwise use an empty string
        url: window.location.href, // URL for the Product Page. Only required for dl_add_to_cart.
      },
    ];
    
    const userProperties = getUserProperties();

    // BEGIN CUSTOM EDIT: Elevar View Item Event | Date: 2025-01-24 | What: Existing Elevar view item tracking
    window.ElevarDataLayer.push({
      event: "dl_view_item",
      user_properties: userProperties,
      ecommerce: {
        currencyCode: window.Shopify.currency.active,
        detail: {
          actionField: {
            list: location.pathname, // this should be the collection page URL that user clicked product from
            action: "detail",
          },
          products: products, // See the products array below
        },
      },
    });
    // END CUSTOM EDIT

    // BEGIN CUSTOM EDIT: Stape View Item Event | Date: 2025-01-24 | What: Add Stape.io view_item_stape datalayer event for quick modals
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_item_stape",
      ecommerce: {
        currency: window.Shopify.currency.active,
        value: (selectedVariant.price / 100).toString(),
        items: [
          {
            item_name: product.title,
            item_id: product.id.toString(),
            item_sku: selectedVariant.sku || "",
            item_brand: product.vendor || "",
            item_category: product.product_type || "",
            item_variant: selectedVariant.title || "",
            price: (selectedVariant.price / 100).toString(),
            variant_id: selectedVariant.id.toString()
          }
        ]
      }
    });
    // END CUSTOM EDIT
  } catch (Error) {
    console.error("Error in handleViewItemEvent: ", Error);
  }
};

async function handleProductSelectEvent(form) {
  try {
    const product = await fetchProductData(window.location.pathname);
    
    if (!product) {
      return;
    }
    
    const selectedVariantId = form.querySelector(".product-single__variants")?.value;
    
    if (!selectedVariantId) {
      return;
    }
    
    const selectedVariant = product.variants.find((variant) => variant.id == parseInt(selectedVariantId));
    
    if (!selectedVariant) {
      return;
    }

    let variantImage = "";
    variantImage = product.images.find((image) => image.id == selectedVariant.image_id);

    const products = [
      {
        id: selectedVariant.sku, // SKU
        name: product.title, // Product title
        brand: product.vendor,
        category: product.product_type,
        variant: selectedVariant.title,
        price: selectedVariant.price,
        list:
          window.location.pathname.split("/products")[0] ||
          window.location.pathname, // The list the product was discovered from
        product_id: product.id.toString(), // The product_id
        variant_id: selectedVariant.id.toString(), // id or variant_id
        compare_at_price: selectedVariant.compare_at_price || "0.0", // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
        image: variantImage.src || "", // If available, otherwise use an empty string
        url: window.location.href, // URL for the Product Page. Only required for dl_add_to_cart.
      },
    ];

    // position: parseInt(position)
    
    const userProperties = getUserProperties();
    
    window.ElevarDataLayer.push({
      event: "dl_select_item",
      user_properties: userProperties,
      ecommerce: {
        currencyCode: window.Shopify.currency.active,
        click: {
          actionField: {
            list: location.pathname, // this should be the collection page URL that user clicked product from
            action: "click",
          },
          products: products, // See the products array below
        },
      },
    });
  } catch (Error) {
    console.error("Error in handleProductSelectEvent: ", Error);
  }
};

async function handleViewCartEvent(drawer) {
  if (!drawer || drawer.getAttribute("id") != "CartDrawer") return;
  
  const userProperties = getUserProperties();
  
  try {
    const cartItems = await fetchCart();
    let impressions = [];
    let stapeItems = [];
    let totalQuantity = 0;
    
    cartItems.items && cartItems.items.forEach((cartItem, index) => {
      impressions.push({
        id: cartItem.sku, // SKU
        name: cartItem.product_title, // Product title
        brand: cartItem.vendor,
        category: cartItem.product_type,
        variant: cartItem.title,
        price: (cartItem.price / 100).toString(),
        quantity: cartItem.quantity.toString(), // Only required for dl_view_cart
        product_id: cartItem.product_id.toString(), // The product_id
        variant_id: cartItem.id.toString(), // id or variant_id
        compare_at_price: cartItem.compare_at_price || "", // If available
        position: index + 1,
        url: cartItem.url
      });

      // Prepare Stape.io items format
      stapeItems.push({
        item_name: cartItem.product_title,
        item_id: cartItem.product_id.toString(),
        item_sku: cartItem.sku || "",
        item_brand: cartItem.vendor || "",
        item_category: cartItem.product_type || "",
        item_variant: cartItem.title || "",
        price: (cartItem.price / 100).toString(),
        quantity: cartItem.quantity,
        variant_id: cartItem.id.toString()
      });

      totalQuantity += cartItem.quantity;
    })
  
    // BEGIN CUSTOM EDIT: Elevar View Cart Event | Date: 2025-01-24 | What: Existing Elevar view cart tracking
    window.ElevarDataLayer.push({
      event: "dl_view_cart",
      user_properties: userProperties,
      cart_total: (cartItems.total_price / 100).toString(),
      ecommerce: {
        currencyCode: window.Shopify.currency.active,
        actionField: {
          list: "Shopping Cart"
        },
        impressions: impressions,
      },
    });
    // END CUSTOM EDIT

    // BEGIN CUSTOM EDIT: Stape View Cart Event | Date: 2025-01-24 | What: Add Stape.io view_cart_stape datalayer event for cart drawer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_cart_stape",
      cart_quantity: totalQuantity,
      cart_total: (cartItems.total_price / 100).toString(),
      ecommerce: {
        currency: window.Shopify.currency.active,
        items: stapeItems
      }
    });
    // END CUSTOM EDIT
    
  } catch (error) {
    console.error("Error in cart drawer event: ", error)
  }
};

function fetchCart() {
  return fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { return data });
}

async function fetchProductData(url) {
  try {
    const response = await fetch(`${url}.json`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const productData = await response.json();

    // Assuming product information is nested under 'product' key in the JSON response
    const product = productData.product;

    return product;
  } catch (error) {
    console.error("Error:", error);
    // Handle the error or redirect to an error page
    return null;
  }
}

function getUserProperties() {
  if (typeof window === "undefined" || !window.customerData) {
    return {
      user_consent: "",
      visitor_type: "guest",
    };
  }

  const customer = window.customerData.shopifyCustomer;

  if (!customer) {
    return {
      user_consent: "",
      visitor_type: "guest",
    };
  }
  
  const userProperties = {
    // The following fields aren't required if unavailable
    customer_address_1: "",
    customer_address_2: "",
    customer_city: "",
    customer_country: Shopify.country,
    customer_email: customer.email,
    customer_first_name: customer.first_name || "",
    customer_id: customer.id.toString(),
    customer_last_name: customer.last_name || "",
    customer_order_count: customer.orders_count.toString() || "0",
    customer_phone: customer.phone || "",
    customer_province: "",
    customer_province_code: "",
    customer_tags: customer.tags.length > 0 ? customer.tags.join(",") : "",
    customer_total_spent: customer.total_spent || "0.0",
    customer_zip: "",

    // The following fields are required
    user_consent: "", // Use an empty string
    visitor_type: "logged_in", // "logged_in" || "guest"
  };
  
  const mainAddress = customer.addresses?.[0];
  
  if (mainAddress) {
    userProperties.customer_address_1 = mainAddress.address1 ?? "";
    userProperties.customer_address_2 = mainAddress.address2 ?? "";
    userProperties.customer_city = mainAddress.city ?? "";
    userProperties.customer_province = mainAddress.province ?? "";
    userProperties.customer_province_code = mainAddress.province_code ?? "";
    userProperties.customer_zip = mainAddress.zip ?? "";
  }

  return userProperties;
    
  //CHANGE PROPERTIES BELOW
};



document.addEventListener('DOMContentLoaded', () => {
  init();
});

document.addEventListener('DOMContentLoaded', function() {
  const chatLinks = document.querySelectorAll('.js-open-chat');
  chatLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      if (typeof GorgiasChat !== 'undefined') {
        GorgiasChat.open();
      } else {
        console.warn('GorgiasChat is not defined');
      }
    });
  });
});